export type InvoiceDTO = {
    'id': number,
    'invoiceId': string,
    'providerBusinessName': string,
    'providerStreet': string,
    'providerCity': string,
    'providerZipCode': string,
    'providerIco': string,
    'providerDic': string,
    'providerIcDph': string,
    'providerPhone': string,
    'providerEmail': string,
    'providerWeb': string,
    'providerBankName': string,
    'providerSwift': string,
    'providerIban': string,
    'providerBankAccountNumber': string,
    'providerBankCode': string,
    'providerDph7aParagraph': boolean,
    'providerVatPayer': boolean,
    'customerBusinessName': string,
    'customerFirstName': string,
    'customerLastName': string,
    'customerStreet': string,
    'customerCity': string,
    'customerZipCode': string,
    'customerIco': string,
    'customerDic': string,
    'customerIcDph': string,
    'customerPhone': string,
    'customerEmail': string,
    'customerWeb': string,
    'customerBankName': string,
    'customerSwift': string,
    'customerVatPayer': boolean,
    'customerDph7aParagraph': boolean,
    'customerIban': string,
    'customerBankAccountNumber': string,
    'customerBankCode': string,
    'preItemText': string,
    'invoiceCreationDate': string,
    'invoiceDueDate': string,
    'serviceRealizationDate': string,
    'paymentType': PaymentType,
    'invoiceItems':  InvoiceItemDto[],
    'total': number,
    'dphValue': number,
    'totalWithDph': number,
    'totalWithoutDph': number,
    'invoiceCreatedByName': string,
    'invoiceCreatedByEmail': string,
    'referenceId': string,
    'constantId': string,
    'orderNumber': string,
    'orderDate': string,
    'createdAt': string,
    'logo': string,
    'signature': string,
    'updatedAt': string,
    'invoiceStatus': 'PAID' | 'UNPAID',
    'specificSymbol': string,
    // yyyy-mm-dd, empty while unpaid
    'paidDate': string,
    // ISO 4217, and how many of it one euro buys
    'currency': string,
    'exchangeRate': number,
    // Percent off the whole document
    'discount': number,
    // ISO 3166-1 alpha-2
    'providerCountry': string,
    'customerCountry': string,
    // Filled only when the delivery goes somewhere other than the billing address
    'deliveryName': string,
    'deliveryStreet': string,
    'deliveryCity': string,
    'deliveryZipCode': string,
    'deliveryCountry': string
}


export enum PaymentType {
    CASH =  'CASH',
    BANK_TRANSFER = 'BANK_TRANSFER'
}

export type InvoiceItemDto = {
    'title': string,
    'quantity': number,
    'unitPrice': number,
    'price': number,
    'dph': number,
    'dphValue': number,
    'totalWithDph': number
    'totalWithoutDph': number
    'description': string,
    'unit': string,
    // Percent off this line
    'discount': number,
    'sku': string
}

export interface InvoicesFilter {
    from: Date | null,
    to: Date | null,
    unpaidOnly: boolean
}

export type InvoiceFormData = Omit<InvoiceDTO, 'id'>
